/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  CreateExerciseMutationRequest,
  CreateExerciseMutationResponse,
  CreateExercise400,
  CreateExercise401,
  CreateExercise403,
} from '../types/CreateExercise.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getCreateExerciseUrl() {
  const res = { method: 'POST', url: `/exercises` as const };
  return res;
}

/**
 * @summary Create exercise
 * {@link /exercises}
 */
export async function createExercise(
  data: CreateExerciseMutationRequest,
  config: Partial<RequestConfig<CreateExerciseMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    CreateExerciseMutationResponse,
    ResponseErrorConfig<CreateExercise400 | CreateExercise401 | CreateExercise403>,
    CreateExerciseMutationRequest
  >({ method: 'POST', url: getCreateExerciseUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
